import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastContainer } from 'react-toastify';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastContainer newestOnTop={true} autoClose={5000} position='top-right' pauseOnHover={true} draggable={true} style={{ whiteSpace: 'pre-wrap' }} />
    <App />
  </React.StrictMode>
);